<div class="row">
    <div class="col-12">
        {{nome}}
    </div>
</div>

<div
    class="row mt-2"
    *ngIf="dettaglio"
>
    <div class="col-12">{{dettaglio}}</div>
</div>


<div
    class="row mt-2"
    *ngIf="ruolo"
>
    <div class="col-12">{{ruolo | ruoloUtente }}</div>
</div>

<div class="row mt-2">
    <div
        class="col-12"
        *ngIf="autorizzazione?.status == 'authorized' && !autorizzazione?.forced"
    >
        <button
            type="button"
            status="success"
            nbButton
            id="abilita"
            class="btn btn-icon"
            (click)="doChangeStatus(autorizzazione)"
        >
            <i class="fas fa-check-circle "></i>
        </button>

        <label class="ml-2">Autorizzato </label>
    </div>

    <div
        class="col-12"
        *ngIf="autorizzazione?.status == 'authorized' && autorizzazione?.forced == true"
    >
        <button
            type="button"
            status="info"
            nbButton
            id="abilita"
            class="btn btn-icon"
            (click)="doChangeStatus(autorizzazione)"
        >
            <i class="fas fa-exclamation-circle"></i>
        </button>

        <label class="ml-2">Autorizzato </label>
    </div>

    <div
        class="col-12"
        *ngIf="autorizzazione?.status == 'requested'"
    >
        <button
            type="button"
            status="warning"
            nbButton
            id="richiedi"
            class="btn btn-icon"
            (click)="doChangeStatus(autorizzazione)"
        >
            <i class="fas fa-question-circle"></i>
        </button>

        <label class="ml-2">Richiesto</label>
    </div>

    <div
        class="col-12"
        *ngIf="autorizzazione?.status == 'denied'"
    >
        <button
            type="button"
            status="danger"
            nbButton
            id="disabilita"
            class="btn btn-icon"
            (click)="doChangeStatus(autorizzazione)"
        >
            <i class="fas fa-times-circle"></i>
        </button>

        <label class="ml-2">Negato</label>
    </div>

    <div
        class="col-12"
        *ngIf="!autorizzazione && associazione_auth_distretti?.autorizzazione?.status == 'authorized'"
    >
        <button
            type="button"
            status="info"
            nbButton
            id="info"
            outline
            class="btn btn-icon"
            (click)="doChangeStatus(autorizzazione)"
        >
            <i class="fas fa-check-circle"></i>
        </button>

        <label
            class="ml-2"
            *ngIf="associazione_auth_distretti?.autorizzazione?.status == 'authorized'"
        >Autorizzato tramite team </label>
    </div>

    <div
        class="col-12"
        *ngIf="!autorizzazione && associazione_auth_distretti?.autorizzazione?.status == 'requested'"
    >
        <button
            type="button"
            status="info"
            nbButton
            id="info"
            outline
            class="btn btn-icon"
            (click)="doChangeStatus(autorizzazione)"
        >
            <i class="fas fa-question-circle"></i>
        </button>
        <label
            class="ml-2"
            *ngIf="associazione_auth_distretti?.autorizzazione?.status == 'requested'"
        >Richiesto tramite team </label>
    </div>


    <div
        class="col-12"
        *ngIf="!autorizzazione && !associazione_auth_distretti?.autorizzazione"
    >
        <button
            type="button"
            status="info"
            nbButton
            id="info"
            outline
            class="btn btn-icon"
            (click)="doChangeStatus(autorizzazione)"
        >
            <i class="fas fa-question-circle"></i>
        </button>
        <label class="ml-2">Non gestito </label>
    </div>

</div>
